/* eslint-disable max-len, i18next/no-literal-string */
import React from 'react';

export function PersonWithSparks(props): JSX.Element {
  return (
    <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <title>Person with Sparks</title>
      <path
        d='M25 22C27.2091 22 29 20.2091 29 18C29 15.7909 27.2091 14 25 14C22.7909 14 21 15.7909 21 18C21 20.2091 22.7909 22 25 22Z'
        stroke='#153F66'
        strokeWidth='2'
      />
      <path
        d='M32 33V30C32 27.7909 30.2091 26 28 26H22C19.7909 26 18 27.7909 18 30V33'
        stroke='#153F66'
        strokeWidth='2'
      />
      <path
        d='M11 12C12.6569 12 14 10.6569 14 9C14 7.34315 12.6569 6 11 6C9.34315 6 8 7.34315 8 9C8 10.6569 9.34315 12 11 12Z'
        stroke='#FF3E51'
        strokeWidth='2'
      />
      <path
        d='M39 12C40.6569 12 42 10.6569 42 9C42 7.34315 40.6569 6 39 6C37.3431 6 36 7.34315 36 9C36 10.6569 37.3431 12 39 12Z'
        stroke='#FF3E51'
        strokeWidth='2'
      />
      <path
        d='M39 44C40.6569 44 42 42.6569 42 41C42 39.3431 40.6569 38 39 38C37.3431 38 36 39.3431 36 41C36 42.6569 37.3431 44 39 44Z'
        stroke='#FF3E51'
        strokeWidth='2'
      />
      <path
        d='M11 44C12.6569 44 14 42.6569 14 41C14 39.3431 12.6569 38 11 38C9.34315 38 8 39.3431 8 41C8 42.6569 9.34315 44 11 44Z'
        stroke='#FF3E51'
        strokeWidth='2'
      />
      <path
        d='M43 28C44.6569 28 46 26.6569 46 25C46 23.3431 44.6569 22 43 22C41.3431 22 40 23.3431 40 25C40 26.6569 41.3431 28 43 28Z'
        stroke='#FF3E51'
        strokeWidth='2'
      />
      <path
        d='M7 28C8.65685 28 10 26.6569 10 25C10 23.3431 8.65685 22 7 22C5.34315 22 4 23.3431 4 25C4 26.6569 5.34315 28 7 28Z'
        stroke='#FF3E51'
        strokeWidth='2'
      />
      <line x1='10' y1='25' x2='15' y2='25' stroke='#FF3E51' strokeWidth='2' strokeLinecap='round' />
      <line
        x1='37.1493'
        y1='11.4063'
        x2='34.4068'
        y2='14.8004'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='1'
        y1='-1'
        x2='5.36368'
        y2='-1'
        transform='matrix(-0.628497 -0.777812 -0.777812 0.628497 37 39.9497)'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='1'
        y1='-1'
        x2='5.36368'
        y2='-1'
        transform='matrix(0.628497 0.777812 0.777812 -0.628497 13 10)'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='12.8507'
        y1='38.5434'
        x2='15.5932'
        y2='35.1493'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line x1='35' y1='25' x2='40' y2='25' stroke='#FF3E51' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
}
